// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgageClosedReason.proto

export enum ENUM_MortgageClosedReason {
  MORTGAGE_CLOSED_REASON_UNSPECIFIED = 'MORTGAGE_CLOSED_REASON_UNSPECIFIED',
  MORTGAGE_CLOSED_REASON_PROPERTY_CLOSED = 'MORTGAGE_CLOSED_REASON_PROPERTY_CLOSED',
  MORTGAGE_CLOSED_REASON_CLIENT_USER_IMPORT_FORCED_UPDATE = 'MORTGAGE_CLOSED_REASON_CLIENT_USER_IMPORT_FORCED_UPDATE',
  MORTGAGE_CLOSED_REASON_PAID_OFF = 'MORTGAGE_CLOSED_REASON_PAID_OFF',
  MORTGAGE_CLOSED_REASON_REPLACED = 'MORTGAGE_CLOSED_REASON_REPLACED',
  MORTGAGE_CLOSED_REASON_OTHER = 'MORTGAGE_CLOSED_REASON_OTHER',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
